import { render, staticRenderFns } from "./GatewayReport.vue?vue&type=template&id=0fde96b4"
import script from "./GatewayReport.vue?vue&type=script&lang=js"
export * from "./GatewayReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports